import { Pagination } from "api/models/response/pagination";
import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";

import { stellaInspectionNoteBusiness } from "api/bussiness/inspection-note/stella-inspection-note/stella-inspection-note-business";
import { GetInpsectionNotes } from "api/models/request/inspection-note/inspection-note";
import { withReset } from "mobx-stores/_extension/with-reset";

import {
  IStellaInspectionNoteProperties,
  StellaInspectionNote,
} from "mobx-stores/_models/inspection-note/stella-inspection-note/stella-inspection-note";
import { withSetPropAction } from "../_extension/with-set-props";
import { DateRangeFilterStore } from "./common/date-range-filter-store";
import { PaginationStore } from "./common/pagination-store";

export const StellaInspectionPrintingManagement = types
  .model({
    open: false,
  })
  .actions(withSetPropAction)
  .actions(withReset);

export const StellaInspectionNoteQueryParams = types
  .model({
    number: "",
    dateRangeFilter: types.optional(DateRangeFilterStore, {}),
    name: "",
    dealingName: "",
  })
  .actions(withSetPropAction);
export const StellaInspectionNoteManagement = types
  .model({
    inspectionNotes: types.optional(types.array(StellaInspectionNote), []),
    pagination: types.optional(PaginationStore, {}),
    inspectionNoteDetail: types.maybeNull(StellaInspectionNote),
    openNew: false,
    openEdit: false,
    openDelete: false,
    queryParams: types.optional(StellaInspectionNoteQueryParams, {}),
    inspectionPrintingManagement: types.optional(
      StellaInspectionPrintingManagement,
      {}
    ),
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    getStellaInspectionNotes: flow(function* getStellaInspectionNotes(
      request?: GetInpsectionNotes
    ) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            filter: self.pagination.filter,
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            sorting: "",
            number: self.queryParams.number,
            dealingName: self.queryParams.dealingName,
            fromDate:
              self.queryParams.dateRangeFilter.fromAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.from
                ? self.queryParams.dateRangeFilter.from
                : undefined,
            toDate:
              self.queryParams.dateRangeFilter.toAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.to
                ? self.queryParams.dateRangeFilter.to
                : undefined,
            name: self.queryParams.name,
          };
        }
        const res =
          (yield stellaInspectionNoteBusiness.getLists<GetInpsectionNotes>(
            request
          )) as Pagination<IStellaInspectionNoteProperties>;
        self.setProp(
          "inspectionNotes",
          res.items?.map((x, i) => ({
            ...x,
            orderNumber:
              i + 1 + self.pagination.pageIndex * self.pagination.itemsPerPage,
          }))
        );
        self.pagination.setProp("totalItems", res.totalCount);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
    getStellaInspectionNoteDetail: flow(function* getStellaInspectionNoteDetail(
      id: string
    ) {
      try {
        self._rootStore.setProp("inProgress", true);
        const res = (yield stellaInspectionNoteBusiness.getById(
          id
        )) as IStellaInspectionNoteProperties;
        self.setProp("inspectionNoteDetail", res);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));
